import React from 'react';
import styled from 'styled-components';
import { graphql, useStaticQuery, navigate } from 'gatsby';
import Img from 'gatsby-image';
import { useIntl } from 'react-intl';

import { Container } from '../global';
import BaseHOC from '../../../../components/BaseHOC';
import { isSalonzone } from '../../../../utils';

const Header = () => {
  const { formatMessage: f, locale } = useIntl();

  const data = useStaticQuery(graphql`
    query {
      fileHu: file(
        sourceInstanceName: { eq: "product" }
        name: { eq: "green-skew-hu" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      fileHuSz: file(
        sourceInstanceName: { eq: "product" }
        name: { eq: "green-skew-hu-sz" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      fileEn: file(
        sourceInstanceName: { eq: "product" }
        name: { eq: "green-skew-en" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      fileEnSz: file(
        sourceInstanceName: { eq: "product" }
        name: { eq: "green-skew-en-sz" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
    }
  `);

  return (
    <HeaderWrapper id="signUp">
      <Container>
        <Flex>
          <HeaderTextGroup>
            {f(
              {
                id: 'headerIntro',
              },
              {
                h1: (...chunks) => <h1>{chunks}</h1>,
                h2: (...chunks) => <h2>{chunks}</h2>,
                ul: (...chunks) => <ul>{chunks}</ul>,
                li: (...chunks) => <li>{chunks}</li>,
                linebreak: <br />,
              },
            )}
            <HeaderForm>
              <HeaderLoginButton
                onClick={() => {
                  navigate(`/${locale}/app/login`);
                }}
              >
                {f({ id: 'loginButton' })}
              </HeaderLoginButton>
              <HeaderSignupButton
                onClick={() => {
                  navigate(`/${locale}/signup`);
                }}
              >
                {f({ id: 'signUp' })}
              </HeaderSignupButton>
            </HeaderForm>
          </HeaderTextGroup>
          <ImageWrapper>
            <StyledImage
              fluid={
                locale === 'en'
                  ? isSalonzone
                    ? data.fileEnSz.childImageSharp.fluid
                    : data.fileEn.childImageSharp.fluid
                  : isSalonzone
                  ? data.fileHuSz.childImageSharp.fluid
                  : data.fileHu.childImageSharp.fluid
              }
            />
            <br />
          </ImageWrapper>
        </Flex>
      </Container>
    </HeaderWrapper>
  );
};

export default BaseHOC(Header);

const HeaderWrapper = styled.header`
  background-color: #f8f8f8;
  padding: 160px 0 80px 0;
  position: relative;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 calc(100% - 5vw));
  @media (max-width: ${(props) => props.theme.screen.md}) {
  }
`;

const HeaderTextGroup = styled.div`
  margin: 0;

  > div {
    width: 100%;
    margin-bottom: -4.5%;
    padding: 0 10px 0 10px;

    /* @media (max-width: ${(props) => props.theme.screen.md}) {
      margin: 0 16px;
    } */
  }

  h1 {
    margin: 0 0 24px;
    color: ${(props) => props.theme.color.primary};
  }

  h2 {
    margin-bottom: 24px;
    ${(props) => props.theme.font_size.regular}
  }

  p {
    margin-bottom: 48px;
  }
`;

const Flex = styled.div`
  display: grid;
  justify-content: space-between;
  align-content: center;
  grid-template-columns: 1fr 1fr;
  padding-bottom: 40px;
  @media (max-width: ${(props) => props.theme.screen.md}) {
    grid-template-columns: 1fr;
    grid-gap: 64px;
  }
`;

const HeaderForm = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 16px;
  margin-top: 32px;
  @media (max-width: ${(props) => props.theme.screen.sm}) {
    flex-direction: column;
  }
`;

const HeaderLoginButton = styled.button`
  font-weight: 500;
  font-size: 14px;
  color: white;
  letter-spacing: 1px;
  height: 60px;
  display: block;
  margin-left: 8px;
  margin-bottom: 10px;
  text-transform: uppercase;
  cursor: pointer;
  white-space: nowrap;
  background: ${(props) => props.theme.color.secondary};
  font-family: ${(props) => props.theme.font.bold};
  font-weight: ${(props) => props.theme.font_weight.bold};
  border-radius: 4px;
  padding: 0px 40px;
  border-width: 0px;
  border-style: initial;
  border-color: initial;
  border-image: initial;
  min-width: 200px;
  outline: 0px;
  &:hover {
    box-shadow: rgba(110, 120, 152, 0.22) 0px 2px 10px 0px;
  }
  @media (max-width: ${(props) => props.theme.screen.md}) {
  }
  @media (max-width: ${(props) => props.theme.screen.sm}) {
    margin-left: 0;
  }
`;

const HeaderSignupButton = styled(HeaderLoginButton)`
  && {
    background: ${(props) => props.theme.color.accent};
    font-family: ${(props) => props.theme.font.bold};
    font-weight: ${(props) => props.theme.font_weight.bold};
  }
`;

const ImageWrapper = styled.div`
  justify-self: end;
  align-self: center;
  @media (max-width: ${(props) => props.theme.screen.md}) {
    justify-self: center;
  }
`;

const StyledImage = styled(Img)`
  width: 500px;
  @media (max-width: ${(props) => props.theme.screen.md}) {
    width: 400px;
  }
  @media (max-width: ${(props) => props.theme.screen.sm}) {
    width: 300px;
    display: none;
  }
`;
